module.exports = __webpack_public_path__ + "static/img/kakao_main.9e8664a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/kakao_main.png
// module id = zN03
// module chunks = 1